import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { AnimationWrapper } from './views/animate';
import { GasStation } from './views/GasStation';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<GasStation />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.GasStation)
	.setTransitionTime(600)
	.build();

export default Layout;
